import React from 'react';
import styled from 'styled-components';
import SEO from '../components/SEO';
import { TripListElement } from '../components/TripListElement';

import Usoutsidehh from '../assets/images/usoutsidehh.jpg';
import Usatbestfoodyet from '../assets/images/usatbestfoodyet.jpg';
import Baileymwjwinterpatrickincaddy from '../assets/images/baileymwjwinterpatrickincaddy.jpg';
import Mwjerinwinterpatrickatcamp from '../assets/images/mwjerinwinterpatrickatcamp.jpg';
import Usoutsideoxford2withwaitress from '../assets/images/usoutsideoxford2withwaitress.jpg';
import Baileykevinpoohwithholyriders from '../assets/images/baileykevinpoohwithholyriders.jpg';
import Usattalladega from '../assets/images/usattalladega.jpg';
import Usatlincolnhh from '../assets/images/usatlincolnhh.jpg';
import Usoutsideroanokehh from '../assets/images/usoutsideroanokehh.jpg';
import Usatsylacauga from '../assets/images/usatsylacauga.jpg';

const TripStyles = styled.div`
  --columns: 3;
  display: grid;
  grid-template-columns: repeat(var(--columns), 1fr);
  gap: 2rem;
  @media (max-width: 700px) {
    --columns: 2;
  }
  @media (max-width: 400px) {
    --columns: 1;
  }
`;

export default function TripsPage() {
  return (
    <>
      <SEO title="Trips" />
      <div>
        <p>
          Hello! Welcome to the archives section. This is where we store and you
          can access all our past adventures to the Huddle House back to the
          point when we started taking pictures.
        </p>
        <TripStyles>
          <TripListElement
            place="Oxford"
            date="1-19-01"
            image={Usoutsidehh}
            altText="Oxford: 1-19-01"
          />
          <TripListElement
            place="Oxford"
            date="1-26-01"
            image={Usatbestfoodyet}
            altText="Oxford: 1-26-01"
          />
          <TripListElement
            place="Moultrie"
            date="2-03-01"
            image={Baileymwjwinterpatrickincaddy}
            altText="Moultrie: 2-03-01"
          />
          <TripListElement
            link="moultrie-tale"
            place="The Moultrie Tale"
            image={Mwjerinwinterpatrickatcamp}
            altText="Moultrie Tale"
          />
          <TripListElement
            place="Oxford, Oxford 2, Jacksonville"
            date="2-10-01"
            image={Usoutsideoxford2withwaitress}
            altText="Oxford, Oxford 2, Jacksonville: 2-10-01"
          />
          <TripListElement
            place="Oxford 2"
            date="2-16-01"
            image={Baileykevinpoohwithholyriders}
            altText="Oxford 2: 2-16-01"
          />
          <TripListElement
            place="Talladega"
            date="2-17-01"
            image={Usattalladega}
            altText="Talladega: 2-17-01"
          />
          <TripListElement
            place="Lincoln"
            date="2-18-01"
            image={Usatlincolnhh}
            altText="Lincoln: 2-18-01"
          />
          <TripListElement
            place="Roanoke"
            date="2-25-01"
            image={Usoutsideroanokehh}
            altText="Roanoke: 2-25-01"
          />
          <TripListElement
            place="Sylacauga"
            date="3-10-01"
            image={Usatsylacauga}
            altText="Sylacauga: 3-10-01"
          />
        </TripStyles>
      </div>
    </>
  );
}
